<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Staff Positions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Staff Positions",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff Positions",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Position Name",
          sortable: true,
        },
        {
          key: "user.name",
          label: "Added By",
          sortable: true,
        },
        {
          key: "addedon",
          label: "Added",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
      },
      deletePos: {
        name: "",
        id: "",
      },
      editPos: {
        name: "",
        id: "",
      },
      existingPosition: [],
      nameError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("staff", ["AllPositions", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllPositions.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllPositions.length;
  },
  methods: {
    ...mapActions({
      FetchPositions: "staff/fetchPositions",
      AddPosition: "staff/addPosition",
      EditPosition: "staff/editPosition",
      DeletePosition: "staff/deletePosition",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllPositions.length;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingPosition = this.AllPositions.filter((position) => {
          return position.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingPosition.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingPosition = [];
      }
    },
    addPosition(modal) {
      if (this.data.name == "") {
        this.nameError = "Position field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingPosition.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddPosition(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editPos.id = values.item.id;
      this.editPos.name = values.item.name;
    },
    showDeleteModal(values) {
      this.deletePos.id = values.item.id;
      this.deletePos.name = values.item.name;
    },
    deletePosition(modal) {
      this.modal = modal;
      this.DeletePosition(this.deletePos);
      this.closeModal(modal);
    },
    editPosition(modal) {
      if (this.editPos.name == "") {
        this.nameError = "Position field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.EditPosition(this.editPos);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchPositions();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_staff_position')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of Staff Positions</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-position-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_staff_position')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllPositions"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-position-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_staff_position')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-position-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_staff_position')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-position-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_staff_position')
          )
        "
      >
        <template #modal-title> Add New Position </template>
        <div class="form-group mb-3">
          <label>Position Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Position Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addPosition('add-position-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-position-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_staff_position')
          )
        "
      >
        <template #modal-title> Edit Position {{ editPos.name }}</template>
        <div class="form-group mb-3">
          <label>Position Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editPos.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editPosition('edit-position-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete position starts -->
      <b-modal
        id="delete-position-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_staff_position')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Position {{ deletePos.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete position {{ deletePos.name }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-position-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deletePosition('delete-position-modal')"
          >
            <i class="fa fa-trash"></i> Proceed</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
